module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Code-4ba81a1d48c39e799ad942457f526db6.svg";